import { FieldDefinition, Reference } from 'sr-types/lib/search/v1/graphql';
import { Identity } from '../common/components/types';
import { ValidatorType } from '../common/form/Validator';

export enum AvailableTypeEnum {
    number = 'number',
    text = 'text',
    termset = 'termset',
    time = 'time',
    date = 'date',
    boolean = 'boolean',
    decimal = 'decimal',
    measurement = 'measurement',
    calculationType = 'calculationType',
    note = 'note',
    reference = 'reference',
    location = 'location'
}

export enum SelectTypeEnum {
    single = 'singleSelect',
    multi = 'multiSelect'
}

export type TermsetSelectType = (typeof SelectTypeEnum)[keyof typeof SelectTypeEnum];
export type AvailableType = (typeof AvailableTypeEnum)[keyof typeof AvailableTypeEnum];

/**
 * Type is like a class, Field is like an instance of that class, Attribute is a Field with a value.
 */
export interface Type {
    id?: string;
    typeName: string;
    fieldType: AvailableType;
    description: string;
}

/**
 * Field definition extends the type with name and label + type specific properties
 */
export interface Field extends Type {
    name: string;
    label: string;
    group: string;
}

export interface TextField extends Field {}

export interface NumberField extends Field {
    min: number;
    max: number;
}

export interface TermsetField extends Field {
    termset: string;
    selectType?: TermsetSelectType;
    newTermset?: string[];
    isMultiSelect?: boolean;
    allowCreate?: boolean;
}

export interface FieldDefinitionInput {
    identity: Identity;
    name: string;
    label: string;
    fieldType: string;
    description: string;
    group: string;
    enabled: boolean;
    metadata: string;
    isRequired: boolean;
    isKey: boolean;
    sequence: number;
}

export interface FieldDefinitionWithDescription extends FieldDefinition {
    description: string;
}
export interface DecimalField extends Field {
    min: number;
    max: number;
    decimalsNumber: number;
}
export interface MeasurementField extends Field {
    min: number;
    max: number;
    decimalsNumber: number;
    unit?: string;
    measurementType?: string;
}

export interface ReferenceField extends Field {
    entityToReference: string;
    selectType?: TermsetSelectType;
    isMultiSelect?: boolean;
    allowCreate?: boolean;
}

export interface LocationField extends Field {
    selectType?: TermsetSelectType;
    isMultiSelect?: boolean;
    allowedLocationTypes?: string | string[];
}

/**
 * Attribute extends the Field with value
 */
export interface Attribute extends Field {
    isMultiSelect?: boolean;
    value: any;
    metadata?: string;
    fieldDefinitionReference?: Reference;
}
export interface TextAttribute extends Attribute {
    value: string;
}
export interface NumberAttribute extends Attribute {
    value: number;
}
export interface TermsetAttribute extends Attribute {
    value: Reference;
}
export interface DateAttribute extends Attribute {
    value: string;
}
export interface TimeAttribute extends Attribute {
    value: string;
}
export interface MeasurementAttribute extends Attribute {
    value: string;
}

export type FieldTypesType = {
    [key in AvailableType]: Type;
};

export type AttributeValidationRulesType = {
    [key in AvailableType]: (field?: Field) => ValidatorType[];
};
